import { action, observable } from 'mobx';

import MessagingService from 'services/MessagingService/MessagingService';
import {
  TWITTER_ACCOUNT_INFO_ERROR,
  TWITTER_ACCOUNT_INFO_RESPONSE,
  TWITTER_TWEET_ERROR,
  TWITTER_TWEET_RESPONSE,
} from 'services/MessagingService/EventNames';
import TwitterService from 'services/TwitterService';
import APIStates from 'enum/APIStates';
import twitterApiResponses from 'enum/twitterApiResponses';


class TwitterStore {
  @observable authenticated = false;
  @observable apiStatuses = {
    accountInfoRequest: APIStates.INITIAL,
    sendTweetRequest: APIStates.INITIAL,
    authenticationRequest: APIStates.INITIAL,
  };

  @observable sendTweetError = null;

  constructor() {
    this.messagingService = new MessagingService();
    this.messagingService.on(TWITTER_ACCOUNT_INFO_RESPONSE, this._handleTwitterAccountInfoResponse);
    this.messagingService.on(TWITTER_ACCOUNT_INFO_ERROR, this._handleTwitterAccountInfoError);
    this.messagingService.on(TWITTER_TWEET_RESPONSE, this._handleTweetResponse);
    this.messagingService.on(TWITTER_TWEET_ERROR, this._handleTweetError);
  }

  destructor() {
    this.messagingService.off(TWITTER_ACCOUNT_INFO_RESPONSE, this._handleTwitterAccountInfoResponse);
    this.messagingService.off(TWITTER_ACCOUNT_INFO_ERROR, this._handleTwitterAccountInfoError);
    this.messagingService.off(TWITTER_TWEET_RESPONSE, this._handleTweetResponse);
    this.messagingService.off(TWITTER_TWEET_ERROR, this._handleTweetError);
  }

  @action getAccountInfo = (username) => {
    this.apiStatuses.accountInfoRequest = APIStates.PENDING;
    TwitterService.getAccountInfo(username);
  };

  @action sendTweet = (message, attachment, username) => {
    this.apiStatuses.sendTweetRequest = APIStates.PENDING;
    TwitterService.sendTweet(message, attachment, username);
  };

  @action _handleTwitterAccountInfoResponse = ({ data: { connected } }) => {
    this.authenticated = connected;
    this.apiStatuses.accountInfoRequest = APIStates.LOADED;
  };

  @action _handleTwitterAccountInfoError = () => {
    this.apiStatuses.accountInfoRequest = APIStates.ERROR;
  };

  @action setAuthenticated = (value) => {
    this.authenticated = value;
  };

  @action _handleTweetResponse = () => {
    this.apiStatuses.sendTweetRequest = APIStates.LOADED;
    this.sendTweetError = null;
  };

  @action _handleTweetError = ({ response: { data: { status } } }) => {
    this.sendTweetError = twitterApiResponses[status];
    this.apiStatuses.sendTweetRequest = APIStates.ERROR;
  };

  @action clearSendTweetError = () => {
    this.sendTweetError = null;
    this.apiStatuses.sendTweetRequest = APIStates.INITIAL;
  };
}

export default new TwitterStore();
